// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  JOBS: '/jobs',
  CANDIDATES: '/candidates',
  AGENTS: '/agents',
  MATCHES: '/matches',
  INTERVIEWS: '/interviews',
  REPORTS: '/reports',
  AUTOMATIONS: '/automations',
  HIRING_AGENTS: '/hiring-agents',
  PUBLIC: '/public',
  SETTINGS: '/settings',
  ORG_SETTINGS: '/organization-settings',
  GETTING_STARTED: '/getting-started',
  NEW_CANDIDATES: '/new-candidates',
  CREATE_JOB: '/create-job',
  CANDIDATE_EVIDENCE_VIEW: '/candidate-evidence-view',
  BILLING: '/billing',
  INTEGRATIONS: '/integrations',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/sign-in`,
      verifyEmail: `${ROOTS.AUTH}/verify-email`,
      onBoarding: `${ROOTS.AUTH}/onboarding`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  // JOBS
  jobs: {
    root: ROOTS.JOBS,
    jobDetails: `${ROOTS.JOBS}/job-details`,
    editorSample: `${ROOTS.JOBS}/editor-sample`,
    dashboard: `${ROOTS.JOBS}/dashboard`,
    candidates: `${ROOTS.JOBS}/candidates`,
    forms: `${ROOTS.JOBS}/forms`,
    workflow: `${ROOTS.JOBS}/workflow`,
    reports: `${ROOTS.JOBS}/reports`,
    createJob: `${ROOTS.JOBS}/create-job`,
    interviewHub: `${ROOTS.JOBS}/interview-hub`,
    interviewAgenda: `${ROOTS.JOBS}/interview-agenda`,
    interviewEvaluation: `${ROOTS.JOBS}/interview-evaluation`,
    integrity: `${ROOTS.JOBS}/integrity`,
    compare: `${ROOTS.JOBS}/compare`,
    jobSettings: `${ROOTS.JOBS}/job-settings`,
    jobReport: `${ROOTS.JOBS}/job-report`,
  },

  //CREATE JOBS
  createJob: {
    root: ROOTS.CREATE_JOB,
  },
  // CANDIDATE EVIDENCE VIEW
  candidateEvidenceView: {
    root: ROOTS.CANDIDATE_EVIDENCE_VIEW,
  },
  // GETTING STARTED
  gettingStarted: {
    root: ROOTS.GETTING_STARTED,
  },
  // CANDIDATES
  candidates: {
    root: ROOTS.CANDIDATES,
  },
  // AGENTS
  agents: {
    root: ROOTS.AGENTS,
  },
  // HIRING AGENTS
  hiringAgents: {
    root: ROOTS.HIRING_AGENTS,
  },
  // MATCHES
  matches: {
    root: ROOTS.MATCHES,
  },
  // INTERVIEWS
  interviews: {
    root: ROOTS.INTERVIEWS,
  },
  // REPORTS
  reports: {
    root: ROOTS.REPORTS,
  },
  // AUTOMATIONS
  automations: {
    root: ROOTS.AUTOMATIONS,
  },
  // PUBLIC JOBS
  public: {
    root: ROOTS.PUBLIC,
  },
  // SETTINGS
  settings: {
    root: ROOTS.SETTINGS,
  },
  // ORG SETTINGS
  orgSettings: {
    root: ROOTS.ORG_SETTINGS,
    info: `${ROOTS.ORG_SETTINGS}/info`,
    jobBoardEmbed: `${ROOTS.ORG_SETTINGS}/job-board-embed`,
    integrations: `${ROOTS.ORG_SETTINGS}/integrations`,
    billing: `${ROOTS.ORG_SETTINGS}/billing`,
    members: `${ROOTS.ORG_SETTINGS}/members`,
    invitations: `${ROOTS.ORG_SETTINGS}/invitations`,
    knowledgeBase: `${ROOTS.ORG_SETTINGS}/knowledge-base`,
    formTemplates: `${ROOTS.ORG_SETTINGS}/form-templates`,
    notifications: {
      root: `${ROOTS.ORG_SETTINGS}/notification`,
      emailTemplates: `${ROOTS.ORG_SETTINGS}/notification/email-templates`,
    },
  },

  //New Candidates
  newCandidates: {
    root: ROOTS.NEW_CANDIDATES,
    candidateDetails: `${ROOTS.NEW_CANDIDATES}/candidate-details`,
  },
  
  // Billing callbacks (Stripe success/cancel/portal redirects)
  billing: {
    success: `${ROOTS.BILLING}/success`,
    cancel: `${ROOTS.BILLING}/cancel`,
    portalReturn: `${ROOTS.BILLING}/portal-return`,
  },

  // Integrations OAuth return (a provider sends the browser here after approval)
  integrations: {
    callback: `${ROOTS.INTEGRATIONS}/callback`,
  },

  // Events trial landing page (public — no auth required)
  eventsTrial: '/events-trial',

  // Error pages
  error: {
    itemNotFound: '/error/item-not-found',
  },
};
